// components/GlucoseForm.js
import React, { useState } from "react";
import { auth, db } from "../firebase";
import { collection, addDoc, Timestamp } from "firebase/firestore";

export default function GlucoseForm({ onSave }) {
  const [glucose, setGlucose] = useState("");
  const [mealTime, setMealTime] = useState("Fasting");
  const [dateTime, setDateTime] = useState("");

  const handleSave = async (e) => {
    e.preventDefault();
    const user = auth.currentUser;
    if (!user) return;

    try {
      await addDoc(collection(db, "users", user.uid, "glucoseReadings"), {
        glucose: Number(glucose),
        mealTime,
        dateTime: dateTime
          ? Timestamp.fromDate(new Date(dateTime))
          : Timestamp.now(),
      });

      if (onSave) onSave();
      setGlucose("");
      setMealTime("Fasting");
      setDateTime("");
    } catch (err) {
      console.error("Error saving glucose:", err);
    }
  };

  return (
    <form onSubmit={handleSave} className="form-container">
      <input
        type="number"
        placeholder="Glucose (mg/dL)"
        value={glucose}
        onChange={(e) => setGlucose(e.target.value)}
        required
      />
      <select value={mealTime} onChange={(e) => setMealTime(e.target.value)}>
        <option>Fasting</option>
        <option>After Meal</option>
      </select>
      <input
        type="datetime-local"
        value={dateTime}
        onChange={(e) => setDateTime(e.target.value)}
      />
      <button type="submit" className="save-btn">Save Reading</button>
    </form>
  );
}
